import { __rest } from '../../_virtual/_tslib.js';
import React__default from 'react';
import ReactSkeleton from 'react-loading-skeleton';
import classNames from 'classnames';
import './Skeleton.scss.js';

const Skeleton = (_a) => {
    var { type } = _a, props = __rest(_a, ["type"]);
    return (React__default.createElement("span", { className: classNames("skeleton-wrapper", type) },
        React__default.createElement(ReactSkeleton, Object.assign({}, props))));
};

export { Skeleton as default };
//# sourceMappingURL=Skeleton.js.map
